import { useDoubleClickProtection } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/language';
import ENV from '../../base/env';
import './Banner.scss';

interface IBannerProps {
  show: boolean;
  onClick: () => void;
}

export default function Banner({ show, onClick }: Readonly<IBannerProps>) {
  const { t } = useTranslation();
  const onClickHandler = useDoubleClickProtection(onClick);
  const title = t('MedAwareness.Banner.Title');
  const imageSrc = `${ENV.AssetsBaseUrl}/feature/med-awareness/icon-med.svg`;
  if (!show) {
    return null;
  }
  return (
    <div className="med-banner-container">
      <button className="container" onClick={onClickHandler}>
        <img src={imageSrc} alt={title} />
        <h3 className="med-banner">{title}</h3>
      </button>
    </div>
  );
}
